import React from 'react'

const Space = (props) => {
  const { size = '16px' } = props

  return <div style={{ marginTop: size }} />
}

export default Space
